import { render, staticRenderFns } from "./RmpDropzone.vue?vue&type=template&id=4e4c1b59&scoped=true"
import script from "./RmpDropzone.vue?vue&type=script&lang=js"
export * from "./RmpDropzone.vue?vue&type=script&lang=js"
import style0 from "./RmpDropzone.vue?vue&type=style&index=0&id=4e4c1b59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c1b59",
  null
  
)

export default component.exports